/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 現在ユーザーの有効権限を取得し、ページアクセス可否を判定するフック。
 * @graph-connects /permissions/me [calls] 現在ユーザーの権限一覧を取得
 */

import { useQuery } from '@tanstack/react-query';
import { permissionsApi } from '../lib/permissions-api.js';
import { queryKeys } from '../lib/query-keys.js';

/** @graph-connects none */
export function usePermissions() {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.permissions.me,
    queryFn: permissionsApi.getMyPermissions,
    staleTime: 60_000,
  });

  const permissions = data?.permissions ?? ['home'];

  return {
    permissions,
    roleIds: data?.roleIds ?? [],
    isLoading,
    hasPermission: (key: string) => permissions.includes(key),
    hasAnyPermission: (keys: string[]) => keys.some((k) => permissions.includes(k)),
  };
}
